import template from './template.html';
import api from '../../api';
import { get } from 'lodash';
import { processPageData } from '../../store/modules/pages';
import he from 'he';
import scrollIntoView from 'scroll-into-view';

import GlobalFooter from '../../components/global-footer';


export default {
    name: 'genericPage',
    template: template,

    components: {
        GlobalFooter,
    },

    data() {
        return {
            loading: false,
            preview: null,
            notFound: false,
        };
    },

    computed: {
        isIOS() {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        },
        page() {
            if ( this.isPreview ) {
                return this.preview;
            }
            return this.$store.getters.getPageByPath(
                this.$route.path
            );
        },

        isPreview() {
            return this.$route.path === '/preview/';
        },
    },

    watch: {
        $route: 'scrollToID',
        '$route.path': 'fetchData',
    },
    
    methods: {
        fetchData() {
            this.notFound = false;
            if ( !this.page ) {
                this.loading = true;
                this.$store.dispatch('fetchPage', this.$route.path)
                    .then(() => {
                        if ( this.page ) {
                            this.afterPageLoad();
                        } else {
                            console.log(`${this.$route.path} not found`);
                            this.notFound = true;
                            this.loading = false;
                        }
                    });
            } else {
                this.afterPageLoad();
            }
        },

        afterPageLoad() {
            let yoast_title = get(this.page, 'yoast_meta.yoast_wpseo_title'); 
            if ( yoast_title ) {
                document.title = yoast_title;
            } else {
                document.title = `Codefam | ${he.decode(this.page.title)}`;
            }
            this.loading = false;
            
            setTimeout(() => {
                this.scrollToID();
            }, 500);
        },

        fetchPreview() {
            let url;
            let id = get(this.$route, 'query.id');
            let nonce = get(this.$route, 'query.nonce');
            let type = get(this.$route, 'query.type');

            if ( type === 'page' ) {
                type = 'pages';
            } else if ( type === 'post' ) {
                type = 'posts';
            }

            url = `${type}/${id}/revisions/?_wpnonce=${nonce}`;
            this.loading = true;

            api.get(url)
                .then((response) => {
                    if ( type === 'posts' ) {
                        this.post = processPageData(response.data[0]);
                    } else {
                        this.preview = processPageData(response.data[0]);
                    }
                    this.loading = false;
                });
        },

        scrollToID() {
            if (this.$route.hash) {
                let headerOffset = 0;
                let id = this.$route.hash.replace('#', '');
                let scrollToEl = document.getElementById(id);
                if (scrollToEl) {
                    scrollIntoView(scrollToEl, {
                        align: {
                            top:0,
                        },
                    });
                }
            }
        },
    },

    created() {
        if ( this.isPreview ) {
            this.fetchPreview();
        } else {
            this.fetchData();
        }
    },

    mounted() {
        this.$el.addEventListener('scroll', (event) => {
            this.$emit('scroll', event);
        });
        this.$emit('scroll');

        setTimeout(() => {
            this.scrollToID();
        }, 500);
    },
};
